import React from 'react'
import { Box, Link, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import CustomTable from 'src/components/PostGraduationContent/PostgraduateComponents/Table/CustomTable'
import { useStyles } from './Selection.styles'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'

const Selection = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const data = [
    {
      action: 'Período da manhã: Prova (Avaliação Técnica). Período da tarde: Redação em língua inglesa',
      period: '23 de fevereiro de 2026'
    },
    {
      action: 'Divulgação das notas da primeira etapa',
      period: '25 de fevereiro de 2026'
    },
    {
      action: 'Interposição de recurso referente à prova e redação',
      period: '26 de fevereiro de 2026'
    },
    {
      action: 'Divulgação das notas após análise de recursos',
      period: '27 de fevereiro de 2026'
    },
    {
      action: 'Arguição oral',
      period: '02 e 03 de março de 2026'
    },
    {
      action: 'Divulgação do resultado da arguição oral',
      period: '04 de março de 2026'
    },
    {
      action: 'Interposição de recurso referente à arguição oral',
      period: '05 de março de 2026'
    },
    {
      action: 'Divulgação do resultado final após recursos',
      period: '06 de março de 2026'
    },
    {
      action: 'Aula inaugural',
      period: '12 de março de 2026'
    }
  ]
  const rows = [
    [
      <>
        Inscrições on-line no site
        <br />
        <Link
          href="https://si3.ufc.br/sigaa/public"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.si3.ufc.br/sigaa/public
        </Link>
        <br />
        <small>
          (selecione a aba processos seletivos - lato sensu)
        </small>
      </>,
      '02 a 20 de fevereiro de 2026'
    ],
    ...data.map((row) => [row.action, row.period])
  ]
  return (
    <>
        <Typography className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.selc.tab-title')}
        </Typography>

      <Box className={classes.contentContainer}>
        <Typography className={classes.paragraph}>
          As inscrições estarão abertas no{' '}
            período 08h do dia 02 de fevereiro de 2026 às
            23h59min do dia 20 de fevereiro de 2026
          . O preenchimento da ficha de inscrição deverá ser feito pela
          internet, via SIGAA, por meio do endereço eletrônico:{' '}
          <Link
            href="https://si3.ufc.br/sigaa/public"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.si3.ufc.br/sigaa/public
          </Link>{' '}
          (selecione a aba processos seletivos - lato sensu).
        </Typography>
        <Typography className={classes.paragraph}>
          Adicionalmente, o(a) candidato(a) deverá enviar os seguintes
          documentos:
        </Typography>
        <ul className={classes.dotList}>
          <li>Documento de identificação oficial com foto;</li>
          <li>
            Comprovante de inscrição gerado e emitido pelo SIGAA;
          </li>
          <li>
            Termo de compromisso preenchido e assinado (Anexo I);
          </li>
          <li>
            Comprovante de conclusão de curso superior;
          </li>
          <li>
            Comprovante de vínculo com a UFC (quando aplicável);
          </li>
          <li>
            Barema curricular preenchido e documentos comprobatórios;
          </li>
          <li>
            Carta de motivação em PDF.
          </li>
        </ul>
        <Typography className={classes.paragraph}>
          Veja abaixo o cronograma do processo seletivo:
        </Typography>
        <Box className={classes.tableContainer}>
          <CustomTable
            headers={[
              t('news.postgraduate.selc.action'),
              t('news.postgraduate.selc.period')
            ]}
            rows={rows}
          />
        </Box>
      </Box>
    </>
  )
}

export default Selection
